import {
  MAX_CHARACTER_EMAIL_VALIDATION,
  MAX_CHARACTER_INPUT_VALIDATION,
  MAX_CHARACTER_ZIP_CODE,
  MAX_COMPANY_ADDRESS_INPUT_VALIDATION,
  MAX_TEXT_INPUT_VALIDATION,
  MAX_CHARACTER_PHONE_VALIDATION,
  MAX_PARTNER_NAME_INPUT_VALIDATION,
  MAX_REPRESENTATIVE_NAME_INPUT_VALIDATION,
} from "@/constants/common";
import { validator } from "@/utils/validator";
import { useMemo } from "react";

export const useGetPartnerSchema = () => {
  const partnerSchema = useMemo(() => {
    return validator.object().shape({
      partnerName: validator.string().trim().required().emptyToNull().label("パートナー名").nameOnly().max(MAX_PARTNER_NAME_INPUT_VALIDATION),
      nationalityId: validator.number().isSelection().label("国籍").required(),
      zipCode: validator.string().emptyToNull().autoTransformToHalfWidth().zipCode().label("郵便番号").notRequired().max(MAX_CHARACTER_ZIP_CODE),
      prefecture: validator.string().trim().emptyToNull().label("都道府県").notRequired().max(MAX_CHARACTER_INPUT_VALIDATION),
      city: validator.string().trim().emptyToNull().label("市区町村").notRequired().max(MAX_CHARACTER_INPUT_VALIDATION),
      address: validator
        .string()
        .trim()
        .emptyToNull()
        .nullable()
        .label("都道府県・市区町村以外の住所")
        .notRequired()
        .max(MAX_COMPANY_ADDRESS_INPUT_VALIDATION),
      location: validator.string().trim().emptyToNull().label("所在地").notRequired().max(MAX_COMPANY_ADDRESS_INPUT_VALIDATION),
      contactPerson: validator.string().trim().emptyToNull().label("担当者").nameOnly().notRequired().max(MAX_REPRESENTATIVE_NAME_INPUT_VALIDATION),
      contactMethod: validator.number().isSelection().emptyToNull().label("連絡方法").notRequired().max(MAX_CHARACTER_INPUT_VALIDATION),
      phoneNumber: validator
        .string()
        .trim()
        .emptyToNull()
        .label("電話番号")
        .autoTransformToHalfWidth()
        .notRequired()
        .isInternationalTelNumber()
        .max(MAX_CHARACTER_PHONE_VALIDATION),
      email: validator.string().trim().emptyToNull().email().label("メールアドレス").notRequired().max(MAX_CHARACTER_EMAIL_VALIDATION),
      contractInfo: validator.string().trim().emptyToNull().label("契約情報").notRequired().max(MAX_CHARACTER_INPUT_VALIDATION),
      billingInfo: validator.string().trim().emptyToNull().label("請求情報").notRequired().max(MAX_CHARACTER_INPUT_VALIDATION),
      otherContacts: validator.string().trim().emptyToNull().label("その他連絡先").notRequired().max(MAX_CHARACTER_INPUT_VALIDATION),
      memo: validator.string().trim().emptyToNull().label("メモ").max(MAX_TEXT_INPUT_VALIDATION).notRequired(),
      laborBureauStatus: validator.boolean().notRequired(),
      sendingOrganization: validator.boolean().notRequired(),
      id: validator.number().notRequired(),
    });
  }, []);

  return { partnerSchema };
};
